import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ContratoPrestacaoServicos = () => {
    const [conteudoContrato, setConteudoContrato] = useState('');
    const [dataAtualizacao, setDataAtualizacao] = useState('');

    useEffect(() => {
        const getPoliticas = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/get/contrato-prestacao-servicos`);
                console.log('Resposta do contrato de prestação de serviços:', response.data);
                setConteudoContrato(response.data.contrato.Conteudo);
                const data = new Date(response.data.contrato.DataCriacao);
                const dataFormatada = data.toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                    timeZone: "America/Sao_Paulo"
                });
                setDataAtualizacao(dataFormatada);
            } catch (error) {
                console.error('Erro ao buscar os termos de uso:', error);
            }
        };

        getPoliticas();
    }, []);

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ textAlign: "center", marginBottom: "20px", backgroundColor: "#0b243d", padding: "10px", borderRadius: "8px" }}>
                <img src="/assets/logoClarea01.png" alt="Contrato de Prestação de Serviços" />
            </div>
            <h1>Contrato de Prestação de Serviços</h1>
            <p>Última atualização: {dataAtualizacao}</p><br />

            <div dangerouslySetInnerHTML={{ __html: conteudoContrato }} />
        </div>
    );
}

export default ContratoPrestacaoServicos;